var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_5100)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_798_5100)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_798_5100",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0165 19.9959C15.528 19.9959 19.9959 15.528 19.9959 10.0165C19.9959 4.50503 15.528 0.0371094 10.0165 0.0371094C4.50503 0.0371094 0.0371094 4.50503 0.0371094 10.0165C0.0371094 15.528 4.50503 19.9959 10.0165 19.9959Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_798_5100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.453125 -0.453125H20.483V20.483H-0.453125V-0.453125Z",
    fill: "#E5E5E4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_798_5100",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0168 19.7982C15.4189 19.7982 19.7982 15.4189 19.7982 10.0168C19.7982 4.61465 15.4189 0.235352 10.0168 0.235352C4.61465 0.235352 0.235352 4.61465 0.235352 10.0168C0.235352 15.4189 4.61465 19.7982 10.0168 19.7982Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_798_5100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.254883 -0.254883H20.2894V20.2894H-0.254883V-0.254883Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_798_5100",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 19,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0165 19.0144C14.9859 19.0144 19.0144 14.9859 19.0144 10.0165C19.0144 5.04707 14.9859 1.01855 10.0165 1.01855C5.04707 1.01855 1.01855 5.04707 1.01855 10.0165C1.01855 14.9859 5.04707 19.0144 10.0165 19.0144Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_798_5100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.52832 0.52832H19.5056V19.5056H0.52832V0.52832Z",
    fill: "#4A8CFF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_798_5100",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 12,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7548 8.84984L15.2992 6.99005C15.5218 6.8086 15.6909 6.84984 15.6909 7.18386V12.854C15.6909 13.2292 15.4806 13.188 15.2992 13.0478L12.7548 11.188V8.84984ZM4.14453 7.20036V11.423C4.14865 12.3797 4.92804 13.1509 5.88474 13.1467H12.0497C12.2229 13.1467 12.3631 13.0065 12.3672 12.8333V8.60654C12.3631 7.64984 11.5837 6.87871 10.627 6.88283H4.46206C4.28886 6.88695 4.14865 7.02304 4.14453 7.20036Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_798_5100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6582 6.39648H16.1819V13.6336H3.6582V6.39648Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_5100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_798_5100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.72ef72801f94a8ee29c82ab7ef3f3bfa.svg";
export { ForwardRef as ReactComponent };